// import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    async getPageTree(which) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/resources/page_tree',
          {
            params: {
              which: which,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        // This error is handled by parent function.
        throw error
      }
    },
    async getDocs(file) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/resources/docs',
          {
            params: {
              file: file,
            },
          }
        )
        return result
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
  },
}
